<template>
  <div>
    <NewFr
      v-if="$lang === 'fr'"
      class="badge"
    />
    <NewEn
      v-else
      class="badge"
    />
  </div>
</template>
<script>
import NewFr from '@/assets/images/common/new-fr.svg?inline';
import NewEn from '@/assets/images/common/new-en.svg?inline';

export default {
  name: 'NewProductBadge',
  components: {
    NewFr,
    NewEn,
  },
};
</script>
<style lang="stylus" scoped>
.badge path {
  fill: currentColor;
}
</style>
